import { EFollowType } from '@bonhams1793/bonhams-typescript'

import { LoveIcon, LoveSelectedIcon } from '@nx/fire/assets'
import { FireCard } from '@nx/fire/card'
import { Body } from '@nx/fire/typography'
import { useFollow } from '@nx/get-user-follows'
import { getTranslate } from '@nx/translations'

import {
  FollowCardContainer,
  StyledFireButton,
  StyledHeading,
} from './FireFollowCard.styles'
import translate from './FireFollowCard.translate.json'

const { text } = getTranslate(translate)

export const FireFollowCard = ({
  type,
  itemId,
  metadata,
  baseURL,
  openLogin,
}: FireFollowCardProps) => {
  const { toggleFollow, isFollowing, isLoading } = useFollow({
    type,
    itemId,
    metadata,
    baseURL,
    openLogin,
  })

  const typeName = text(`follow-card.cta.${type}`)
  const followText = isFollowing
    ? text('follow-card.cta.following', {
        entity: typeName,
      })
    : text('follow-card.cta.follow', {
        entity: typeName,
      })

  return (
    <FollowCardContainer>
      <FireCard>
        <StyledHeading $level={4} as="h2">
          {text('follow-card.title')}
        </StyledHeading>
        <Body>{text('follow-card.description', { entity: typeName })}</Body>
        <StyledFireButton
          onClick={toggleFollow}
          disabled={isLoading}
          variant="label"
          startIcon={isFollowing ? LoveSelectedIcon : LoveIcon}
        >
          {followText}
        </StyledFireButton>
      </FireCard>
    </FollowCardContainer>
  )
}

export interface FireFollowCardProps {
  type: EFollowType
  itemId: number | string
  metadata?: {
    auctionId?: number | string
  }
  baseURL: string
  openLogin: () => void
}
